import React from 'react';
import {Content, DefaultImg, LeftSideWrapper, LogoImage, SchoolImage, Title } from './Theme';
import  {ReactComponent as EventImg} from 'assets/images/EventImg.svg';
import { useSelector } from "react-redux";

export const LeftSide = () => {
    const Logo = localStorage.getItem('logoImgEvent');
    const { eventData } = useSelector((state) => state?.Events)

    return (
                    <LeftSideWrapper>
                        <LogoImage src={Logo} alt='Logo' />
                         {eventData?.background? <SchoolImage src={eventData?.background } alt='notFound' style={{ objectFit: 'contain' }} />
                         :<DefaultImg>
                            <EventImg/>
                         </DefaultImg>
                         }
                        
                        <Content haveDisc={eventData?.description}>
                            {/* <Title>Join Our Event</Title> */}
                            {/* <Description>
                            {eventData?.description?.replace(/&lt;/g, '<') !== '<p></p>\n' && (
                            <div className="drawer_description">
                                <p
                                dangerouslySetInnerHTML={{
                                    __html: eventData?.description?.replace(/&lt;/g, '<'),
                                }}
                                ></p>
                            </div>
                            )}
                            </Description> */}
                        </Content>
                    </LeftSideWrapper>
    );
};

